import { defineQuery, useQuery, useQueryCache } from "@pinia/colada";

const wishlistParsed = v.safeParse(wishlistSchema, wishlist);

export const useWishlist = defineQuery(() => {
  const { data: wishlist, isLoading, status, error } = useQuery<Wishlist, Error, Wishlist>({
    key: () => ["wishlist"],
    query: async () => ajaxRequest<Wishlist>("get_wishlist"),
    initialData: wishlistParsed.success ? () => wishlistParsed.output : undefined,
    enabled: !wishlistParsed.success,
    placeholderData: () => ({ products: [] }),
  });
  const isInWishlist = computed(() => (product_id: number) => wishlist.value?.products.some((product) => product.product_id === product_id));
  return { wishlist, isLoading, status, error, isInWishlist };
});

export function useToggleWishlist() {
  const queryCache = useQueryCache();
  const { isLoggedIn } = useAccount();
  const { siteOptions } = useSiteOptions();
  const { mutate, isLoading, isDisabled } = useMutationHandler<{ wishlist: Wishlist }, ToggleWishlist>({
    action: "toggle_wishlist",
    onSuccess: (wishlist) => {
      queryCache.setQueryData(["wishlist"], wishlist);
    },
  });
  function onToggleWishlist(params: ToggleWishlist) {
    if (!isLoggedIn.value) location.href = siteOptions.value.login_url;
    mutate(params);
  }
  return { onToggleWishlist, isLoading, isDisabled };
}
